/**
 * Whether we should call POST /api/device/packet from BLE/serial / saveDeviceDataToDb.
 *
 * - `import.meta.env.DEV`: 로컬에서 비로그인 configuration도 패킷 저장 시도 (백엔드 무인증 허용과 맞춰야 함).
 * - Logged-in: access + refresh (Bearer JWT).
 * - VITE_WEB_CONFIGURATION_PACKET_INGEST_TOKEN (+ 서버 동일 토큰).
 * - VITE_ALLOW_ANONYMOUS_CONFIGURATION_PACKET=true (+ 서버 WEB_CONFIGURATION_ALLOW_ANONYMOUS_PACKET).
 */
export function canSyncPacketToCloud(): boolean {
  if (import.meta.env.DEV) {
    return true;
  }
  const hasSession = Boolean(
    sessionStorage.getItem('access_token') &&
      sessionStorage.getItem('refresh_token')
  );
  const hasPublicIngest = Boolean(
    import.meta.env.VITE_WEB_CONFIGURATION_PACKET_INGEST_TOKEN
  );
  const allowAnonymous =
    import.meta.env.VITE_ALLOW_ANONYMOUS_CONFIGURATION_PACKET === 'true';
  return hasSession || hasPublicIngest || allowAnonymous;
}
